
export function generateCurrentDomainKey(privateKey = 'bjadks.com') {
  const vitualDom = document.createElement('div')
  // eslint-disable-next-line no-undef
  const graphVis = new GraphVis({
    container: vitualDom,
    licenseKey: 'tempkey'
  })

  const urlObject = new URL(window.location.href)
  const websitDomain = urlObject.hostname

  const licenseKey = graphVis.genrateLicenseKey(websitDomain, privateKey)
  return licenseKey
}
